import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

const PaalStats = React.lazy(() => import('./PaalStats'));

const RoutesComponent = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={'/'} element={<PaalStats/>}/>
            </Routes>
        </BrowserRouter>
    )
}

export default RoutesComponent